import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useBloomreach } from '../context/context.js';

function useBloomreachProductRoutes() {
    var ref, ref1;
    const { pageModel  } = useBloomreach();
    var ref2;
    const productRoutes = (ref2 = pageModel === null || pageModel === void 0 ? void 0 : (ref = pageModel.page) === null || ref === void 0 ? void 0 : (ref1 = ref.models) === null || ref1 === void 0 ? void 0 : ref1.productRoutes) !== null && ref2 !== void 0 ? ref2 : {};
    const hasRoutes = productRoutes && Object.keys(productRoutes).length > 0;
    if (!hasRoutes) {
        var ref3;
        console.log(`Could not get productRoutes for page with name ${pageModel === null || pageModel === void 0 ? void 0 : (ref3 = pageModel.page) === null || ref3 === void 0 ? void 0 : ref3.name}, got: ${String(productRoutes)}`);
    }
    // Omit a $ref from the productRoutes object
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const routes = swcHelpers.objectWithoutProperties(productRoutes, [
        "$ref"
    ]);
    return React.useMemo(()=>[
            {
                hasRoutes
            },
            routes
        ]
    , [
        hasRoutes,
        routes
    ]);
}

export { useBloomreachProductRoutes };
//# sourceMappingURL=use-bloomreach-product-routes.js.map
